
import { Injectable } from '@nestjs/common';
import { ErrorResponse, ExcelImportModel, ExcelImportResponse } from '@schemax-whatsapp/shared-models';
import { ExcelImport } from '../entity/excel-import.entity';
import { ExcelImportAdapter } from './adapter/excel-import.adapter';
import { InjectRepository } from '@nestjs/typeorm';
import { Raw, Repository } from 'typeorm';

@Injectable()
export class ExcelImportService {
    constructor(
        private excelImportAdapter: ExcelImportAdapter,
        @InjectRepository(ExcelImport) private excelDumpRepo: Repository<ExcelImport>,
    ) { }

    /**
     * 
     * @param dto 
     * @returns 
     */

    async getPhoneNumers (phoneNumber:string):Promise<any>{
      const response = await this.excelDumpRepo.findOne({
        where : {phoneNumber : Raw(alias => `phone_number = '${phoneNumber}'`)},
      });
      if (response) {
        return response;
      }
      else {
        return null;
      }
    }

    async getEmail (email:string):Promise<any>{
      const response = await this.excelDumpRepo.findOne({
        where : {email : Raw(alias => `email = '${email}'`)},
      });
      if (response) {
        return response;
      }
      else {
        return null;
      }
    }
     
    async saveExcelData(dto:ExcelImportModel[]):Promise<ExcelImportResponse>{
        const flag = new Set()
        for(const element of dto){
          const phnNum = await this.getPhoneNumers(element.phoneNumber)
          if(phnNum){
            return new ExcelImportResponse(false,0,'Phone number already exists')
          }
          const email = await this.getEmail(element.email)
          if(email){
            return new ExcelImportResponse(false,0,'Email already exists')
          }
            const convertedExcelEntity: Partial<ExcelImport> = this.excelImportAdapter.convertDtoToEntity(element);
            const saveExcelEntity : ExcelImport = await this.excelDumpRepo.save(convertedExcelEntity);
            const saveExcelDto :ExcelImportModel = this.excelImportAdapter.covertEntityToDto(saveExcelEntity);
            if(!saveExcelDto){
                flag.add(false)

            }
        }
        if(!flag.has(false)){
            const response = new ExcelImportResponse(true,0,'data saved sucessfully')
            return response
        }else{
            throw new ErrorResponse(0,'Something went wrong')
        }
    }

    /**
     * 
     * @returns 
     */
    async excelImportTableData():Promise<ExcelImportResponse>{
        const dto : ExcelImportModel[]=[];
        const entitydata:ExcelImport[] = await this.excelDumpRepo.find({order:{'memberName' : 'ASC'}})
        if(entitydata){
            const response = new ExcelImportResponse(false,0,'data retrived sucessfully',entitydata)
            return response
        }
    }

}